'use strict';
var analysisGraphEditTpl = require('./graph-edit/graph-edit.html');
var analysisPanelTpl = require('./panel.html');

module.exports = /*@ngInject*/ ["$uibModal", function ($uibModal) {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            ngShow: '=',
            trainData: '=',
            options: '='
        },
        template: analysisPanelTpl,
        link: function (scope) {
            "use strict";
            scope.selected = {
                discriminator: undefined,
                subDiscriminator: undefined,
                allDiscriminators: false,
                allSubDiscriminators: false,
                allSubSubDiscriminators: false,
                aggregateVlinks: undefined,
                reload: false,
                live: false,
                rate: 12,
                useRate: false,
                messageName: scope.ngModel.getCurrentState().messageName
            };

            scope.$watch(function () {
                return scope.ngModel.getCurrentState().messageName === scope.selected.messageName;
            }, function () {
                scope.selected.allSubSubDiscriminators = false;
                scope.selected.allSubDiscriminators = false;
                scope.selected.allDiscriminators = false;

                if (scope.ngModel.hasSubDiscriminator()) {
                    scope.selected.subDiscriminator = scope.ngModel.getSubDiscriminator();
                }
                if (scope.ngModel.hasSubSubDiscriminator()) {
                    scope.selected.subSubDiscriminator = scope.ngModel.getSubSubDiscriminator();
                }
                if(scope.ngModel.hasDiscriminator()){
                    scope.selected.discriminator = scope.ngModel.getDiscriminator();
                }
                scope.selected.rate = scope.ngModel.getRate();
                scope.selected.useRate = scope.ngModel.getUseRate();
                scope.selected.aggregateVlinks = scope.ngModel.isVlinkAggregationEnabled();
                scope.selected.shouldAggregateVlinks = scope.ngModel.shouldAggregateVlinks();

                if (scope.selected.useRate) {
                    setRateClass(scope.selected.rate);
                }
            });

            var setRateClass = function (rate) {
                if (rate < 1) {
                    scope.rateClass = "danger";
                } else if (rate > 59) {
                    scope.rateClass = "success";
                } else {
                    scope.rateClass = "warning";
                }
            };


            scope.clickedLive = function (isLive) {
                scope.$emit('live', isLive);
            };

            scope.addMessageToChart = function () {
                if (scope.selected.allDiscriminators || scope.selected.allSubDiscriminators || scope.selected.allSubSubDiscriminators) {
                    var currentProperties = scope.ngModel.getCurrentProperties();
                    currentProperties.forEach(function (property) {
                        scope.checkProperty(property);
                    });
                }
                scope.$emit('add-message');
            };

            scope.removeMessageFromChart = function () {
                scope.$emit('remove-message');
            };

            scope.setRate = function (rate) {
                scope.ngModel.setRate(rate);
                setRateClass(scope.selected.rate);
            };

            scope.hidePanel = function () {
                scope.ngShow = false;
            };

            scope.openGraphEditor = function (property) {
                scope.modalInstance = $uibModal.open({
                    template: analysisGraphEditTpl,
                    controller: "GraphEditController",
                    resolve: {
                        property: function () {
                            return property;
                        }
                    }
                });
            };

            scope.checkProperty = function (property) {
                scope.ngModel.checkProperties(property, scope.selected.allDiscriminators, scope.selected.allSubDiscriminators);
            };

            scope.allDiscriminatorsClicked = function (allDiscriminators) {
                scope.selected.allSubDiscriminators = allDiscriminators;
            };



            scope.enableVlinkAggregation = function () {
                scope.ngModel.toggleVlinkAggregation();
                scope.selected.aggregateVlinks = scope.ngModel.isVlinkAggregationEnabled();
            };

        }
    };
}];
